import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'
import { ScrollView } from 'react-native'

import { AccountView } from 'partials/AccountView'
import { Page } from 'partials/Page'

import { Separator } from 'widgets/Separator'

import { useCurrentUser } from 'hooks/useCurrentUser'

export const AccountPage = ({ navigation, route }: CompositeScreenProps<any, any>) => {
  const { data: currentUser, isLoading: isUserLoading } = useCurrentUser()

  return (
    <Page
      isLoading={isUserLoading}
      navigation={navigation}
      withBack
      withNav
      backgroundColor='white'
      title='Manage Account'
    >
      <Separator />
      <ScrollView>
        <AccountView
          navigation={navigation}
          route={route}
          currentUser={currentUser}
          isUserLoading={isUserLoading}
        />
      </ScrollView>
    </Page>
  )
}
